import { useAppSelector } from '~/store';
import { selectProfiles } from '~/profile-sidebar/selectors';
/**
 * Deciding if we need to show Threads upgrade modal - it's the case
 * when there's a Twitter draft enabled, which has a Thread, and there's
 * at least one profile with canQueueMoreThreads = false
 */
export const useShowThreadsUpgrade = (post) => {
  const profiles = useAppSelector((state) => selectProfiles(state));

  const canQueueMoreThreadsForAllTwitterProfiles = profiles
    .filter((p) => p.service === 'twitter')
    .reduce(
      (canQueueMoreThreads, p) => p.canQueueMoreThreads && canQueueMoreThreads,
      true
    );
  const hasThread = post?.updateType === 'thread';
  return {
    shouldShowThreadsMigrationModal:
      !canQueueMoreThreadsForAllTwitterProfiles && !!hasThread,
  };
};
